"use client";
import { Pagination, Stack, Typography } from "@mui/material";
import Image from "next/image";
import { TitleGradientText } from "../title_gradient_text";
import { DividerGradient } from "../divider_gradient";
import { useState } from "react";
import { SwiperSlide, Swiper } from "swiper/react";
export function WhyUsSection() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [sw, setSw] = useState<any>();
  const items = [
    {
      title: "อร่อยกลมกล่อม",
      description:
        "น้ำปลาร้าปรุงสุกเข้มข้นตามแบบฉบับเชฟไพรฑูรย์ จึงมีรสชาติเอกลักษณ์เฉพาะ ทำเมนูไหนก็อร่อย เหมือนมีเชฟมาให้ทำทานที่บ้าน",
      icon: "/images/home/why_us_icon_1.png",
      cover: "/images/home/01.jpg",
    },
    {
      title: "สะอาด ปลอดภัย",
      description:
        "ด้วยกระบวนการคัดสรรวัตถุดิบที่มีคุณภาพ และมาตรฐานการผลิต ผู้บริโภคจึงมั่นใจเลือกใช้ผลิตภัณฑ์น้ำปลาร้าเชฟไพรฑูรย์",
      icon: "/images/home/why_us_icon_2.png",
      cover: "/images/home/02.jpg",
    },
    {
      title: "ใส่ใจชุมชนและสิ่งแวดล้อม",
      description:
        "บริษัทฯให้ความสำคัญกับการจัดการน้ำเสียและกลิ่นจากกระบวนการผลิต เพื่อไม่ให้เป็นมลภาวะต่อชุมชนและพื้นที่ใกล้เคียง",
      icon: "/images/home/why_us_icon_3.png",
      cover: "/images/home/03.jpg",
    },
  ];

  return (
    <Stack
      width="100%"
      height="auto"
      py={{
        xs: 15,
        md: 27,
      }}
      px={{
        xs: 4,
        md: 30,
      }}
      gap={{
        xs: 12,
        md: 22.5,
      }}
      direction={{
        xs: "column-reverse",
        md: "row",
      }}
      alignItems={{
        xs: "center",
        md: "stretch",
      }}
    >
      <Stack
        width={{
          xs: "100%",
          md: "50%",
        }}
        justifyContent="center"
        alignItems="center"
      >
        <Swiper
          slidesPerView={1}
          style={{ width: "100%", maxHeight: "560px", borderRadius: "16px" }}
          draggable={false}
          allowTouchMove={false}
          onSwiper={(swiper) => setSw(swiper)}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={item.cover}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "16px",
                }}
                alt="Picture of the Logo"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <Image
          src={coverImg}
          fill
          // width={520}
          // height={520}
          style={{
            objectFit: "cover",
            borderRadius: "16px",
          }}
          alt="Picture of the Logo"
        /> */}
      </Stack>
      <Stack
        width={{
          xs: "100%",
          md: "50%",
        }}
        gap={12}
      >
        <Stack>
          <TitleGradientText
            mt={4}
            variant="body1"
            fontWeight={600}
            textAlign={{
              xs: "center",
              md: "left",
            }}
          >
            ทำไมต้องเลือก
          </TitleGradientText>
          <TitleGradientText
            mt={4}
            variant="h3"
            fontSize={{
              xs: "32px",
              md: "48px",
            }}
            textAlign={{
              xs: "center",
              md: "left",
            }}
          >
            ปลาร้าเซฟไพรฑูรย์
          </TitleGradientText>
        </Stack>
        <Stack gap={6}>
          {items.map((item, index) => (
            <Stack
              gap={6}
              key={`${item.title}-${index}`}
              onClick={() => sw.slideTo(index)}
              onMouseEnter={() => sw.slideTo(index)}
              style={{
                cursor: "pointer",
              }}
            >
              <Stack direction="row" gap={6}>
                <Image src={item.icon} width={44} height={44} alt="" />
                <Stack gap={2}>
                  <Typography variant="body1" fontWeight={600}>
                    {item.title}
                  </Typography>
                  <Typography variant="subtitle1">
                    {item.description}
                  </Typography>
                </Stack>
              </Stack>
              {index !== items.length - 1 && (
                <DividerGradient isVertical={false} />
              )}
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
